import {
	BigNum,
	QUOTE_PRECISION_EXP,
	PRICE_PRECISION,
	User,
} from '@drift-labs/sdk';
import { MaxFundsAvailableBreakdown } from 'src/@types/types';

/**
 * Calculates the max trade size for each side of the position (if flipping position).
 * It is possible for 2 prices to be used in the case of prediction markets, where the "Yes" side price is X and the "No" side price is $1 - X.
 *
 * @param finalSidePrice - The price of the final side of the position
 * @param currentOpenPositionSidePrice - The price of the current side of the position. Zero if user is not flipping position.
 * @param maxTradeSizeUsdc - The max trade size for each side of the position
 */
export const handleTotalMaxTradeSizeCalculation = (
	finalSidePrice: BigNum,
	currentOpenPositionSidePrice: BigNum,
	maxTradeSizeUsdc: ReturnType<User['getMaxTradeSizeUSDCForPerp']>
): MaxFundsAvailableBreakdown => {
	const {
		tradeSize: finalSideTradeSize,
		oppositeSideTradeSize: currentSideTradeSize,
	} = maxTradeSizeUsdc;

	const finalSideMaxQuoteNum = BigNum.from(
		finalSideTradeSize,
		QUOTE_PRECISION_EXP
	).toNum();

	const currentSideMaxQuoteNum = BigNum.from(
		currentSideTradeSize,
		QUOTE_PRECISION_EXP
	).toNum();

	const finalSideMaxBase = !finalSidePrice.eqZero()
		? BigNum.from(finalSideTradeSize, QUOTE_PRECISION_EXP)
				.scale(PRICE_PRECISION, finalSidePrice.val)
				.toNum()
		: 0;

	const currentOpenPositionSideMaxBase = !currentOpenPositionSidePrice.eqZero()
		? BigNum.from(currentSideTradeSize, QUOTE_PRECISION_EXP)
				.scale(PRICE_PRECISION, currentOpenPositionSidePrice.val)
				.toNum()
		: 0;

	return {
		newSide: {
			quoteAmount: finalSideMaxQuoteNum,
			baseAmount: finalSideMaxBase,
		},
		currentSide: {
			quoteAmount: currentSideMaxQuoteNum,
			baseAmount: currentOpenPositionSideMaxBase,
		},
	};
};
